import { Link } from "react-router-dom";

const COMPLIANCE = "J11 provides educational information and consulting services. We do not guarantee credit-score increases, deletion of accurate information, credit approvals, business-bank approvals, or funding. Results vary based on each person's credit profile, business situation, lender requirements, and individual actions. Always verify information with the appropriate creditor, credit bureau, financial institution, or lender.";

const VARIANTS = {
  default: {
    copyright: "© 2026 J11 · Educate II Elevate",
    links: [["/privacy", "Privacy"], ["/terms", "Terms"], ["/contact", "Contact"]],
    extra: "This class is for educational purposes only and is not financial, legal, tax or investment advice. Funding is debt and carries risk; approvals, amounts and terms are set by lenders. Results shown are not typical.",
    note: "This site is not part of or endorsed by Meta, Facebook, Google or YouTube.",
  },
  compact: {
    copyright: "© 2026 J11 · Educate II Elevate · Educational only, not financial or legal advice.",
    links: [["/privacy", "Privacy"], ["/terms", "Terms"]],
  },
  replay: {
    copyright: "© 2026 J11 · Educate II Elevate",
    links: [["/privacy", "Privacy"], ["/terms", "Terms"], ["/refund", "Refund policy"]],
    extra: "Educational content only, not financial, legal, tax or investment advice. No one can guarantee approvals or income. Funding is debt and carries risk; approvals, amounts and terms are set by lenders. Results shown are not typical.",
  },
};

export const Footer = ({ variant = "default" }) => {
  const v = VARIANTS[variant];
  return (
    <footer className="relative" data-testid="site-footer">
      <div className="hairline" aria-hidden="true" />
      <div className="gutter space-y-4 py-12 text-[12px] leading-relaxed text-[#8a857b]">
        <p data-testid="footer-compliance">{COMPLIANCE}</p>
        {v.extra && <p>{v.extra}</p>}
        <div className="flex flex-col gap-2 pt-2 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">{v.copyright}</p>
          <nav className="flex items-center gap-2" aria-label="Legal">
            {v.links.map(([to, label], i) => (
              <span key={to} className="flex items-center gap-2">
                {i > 0 && <span aria-hidden="true">·</span>}
                <Link to={to} className="transition-colors hover:text-[var(--gold)]" data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}-link`}>{label}</Link>
              </span>
            ))}
          </nav>
        </div>
        {v.note && <p>{v.note}</p>}
      </div>
    </footer>
  );
};
